module.exports = __webpack_public_path__ + "static/media/gallery.738a94b7.svg";